var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChallengesCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.0736,
    y: 45.5705,
    width: 45.5705,
    height: 5.33286,
    rx: 2.66643,
    transform: "rotate(-90 58.0736 45.5705)",
    fill: "#E9EDF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.0736,
    y: 45.5705,
    width: 10.8668,
    height: 5.33286,
    rx: 2.66643,
    transform: "rotate(-90 58.0736 45.5705)",
    fill: "#78D504"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5549,
    y: 45.5705,
    width: 45.5705,
    height: 5.33281,
    rx: 2.66641,
    transform: "rotate(-90 43.5549 45.5705)",
    fill: "#E9EDF7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5549,
    y: 45.5705,
    width: 41.364,
    height: 5.33287,
    rx: 2.66643,
    transform: "rotate(-90 43.5549 45.5705)",
    fill: "#78D504"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0369,
    y: 45.5705,
    width: 45.5705,
    height: 5.33286,
    rx: 2.66643,
    transform: "rotate(-90 29.0369 45.5705)",
    fill: "#E9EDF7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0369,
    y: 45.5705,
    width: 31.5488,
    height: 5.33287,
    rx: 2.66643,
    transform: "rotate(-90 29.0369 45.5705)",
    fill: "#78D504"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5188,
    y: 45.5705,
    width: 45.5705,
    height: 5.33287,
    rx: 2.66644,
    transform: "rotate(-90 14.5188 45.5705)",
    fill: "#E9EDF7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5188,
    y: 45.5705,
    width: 23.4863,
    height: 5.33287,
    rx: 2.66643,
    transform: "rotate(-90 14.5188 45.5705)",
    fill: "#78D504"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000038147,
    y: 45.5705,
    width: 45.5705,
    height: 5.33287,
    rx: 2.66644,
    transform: "rotate(-90 3.8147e-06 45.5705)",
    fill: "#E9EDF7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000038147,
    y: 45.5705,
    width: 37.508,
    height: 5.33288,
    rx: 2.66644,
    transform: "rotate(-90 3.8147e-06 45.5705)",
    fill: "#78D504"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesCompleted);
export default __webpack_public_path__ + "static/media/challenges-completed.5dd99b1cd0d5221e9f853ce9dbcb4494.svg";
export { ForwardRef as ReactComponent };